import {
    IdCardWrapper,
    TitleAndCommandsWrapper,
    TitlesWrapper,
    IdCardTitle,
    ModuleTitle,
    CommandsWrapper,
    TextualDetailsWrapper,
    SectionTitle,
    ImagesWrapper,
    ImageWrapper,
    CharacteristicsAndModulesWrapper,
    CharacteristicsWrapper,
    CharacteristicsSectionWrapper,
    CharacteristicWrapper,
    CharacteristicTitle,
    ModulesWrapper,
    ModuleWrapper,
    ModuleImage,
    ModuleNameWrapper,
    ModuleTsCode,
    ModuleName,
    SubMenusWrapper,
    SectionTitleEl,
    SlotLoaderContainer,
    DeleteIdCardButton,
    DiscardChangesButton,
    SaveChangesButton,
    SaveChangesExitWrapper,
    DescriptionAndMainImageWrapper,
    DescriptionAndScopeWrapper,
    CharacteristicInput,
    CharacteristicUnit,
} from './styles';

import ImageViewer from '../ImageViewer';
import SubMenuItem from '../SubMenuItem';
import Loader from '../../components/Loader';
import NotFound from '../../screens/NotFound';
import { Prompt } from 'react-router-dom';
import useObjectElements from '../../hooks/useObjectElements';
import useDeleteImage from '../../hooks/useDeleteImage';
import useSaveChangesProjectIdCard from '../../hooks/useSaveChangesProjectIdCard';
import useDeleteProjectIdCard from '../../hooks/useDeleteProjectIdCard';
import DescriptionEdit from '../DescriptionEdit';
import MainImageEdit from '../MainImageEdit';
import ValidationInput from '../ValidationInput';
import Dropdown from '../Dropdown';
import DocumentsEdit from '../DocumentsEdit';

import {CONTRACT_TYPE_OPTIONS, MOORING_SYSTEM_OPTIONS, MODAL_ACTION, user_roles} from '../../config/enums';
import { useUser } from '../../context/user';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';
import { useState } from 'react';
import {ImageContext} from "../../context/ImageContext";
import {toast} from "react-toastify";
import ModalView from '../ModalView';

const ProjectIdCardEdit = ({ onModalClose }) => {
    const { projectIdCard: idCardData, idCardLoading, idCardImageArray } = useIdCard();
    const {
        object: idCardEditedData,
        setObjectValue: setEditedDataField,
        setMultipleObjectValues: setMultipleEditFields,
    } = useObjectElements({ initialValues: { ...idCardData } });
    const [idCardImages, setIdCardImages] = useState(idCardImageArray);
    const { removeCatalogItem, addCatalogItem, searchFilter,
        updateSearchFilterField, } = useIdCatalogSearch();
    const { saveChanges, isLoading: isLoadingSaveChanges } = useSaveChangesProjectIdCard({ onModalClose });
    const { deleteProjectIdCard, isLoading: isLoadingDelete } = useDeleteProjectIdCard();
    const { deleteImage } = useDeleteImage();

    const shouldRenderNotFound = !Boolean(idCardData) && !idCardLoading;
    const shouldRenderLoader = idCardLoading;
    const { object: modalData, setObject: setModalData, setObjectValue: setModalProp } = useObjectElements({});

    const onCloseModal = () => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
    };

    const handleOnLeavePage = (location, action) => {
        if (action === 'POP') {
            return true;
        }

        if (modalData.modalIsOpen) {
            return true;
        }

        setModalData({
            modalIsOpen: true,
            modalTitle: 'Unsaved data',
            leftBtnTitle: 'NO, Discard Changes',
            rightBtnTitle: 'YES, Save Changes',
            modalDescription: 'Your are about to leave this page without saving. Would you like to save all changes?',
            onCloseModal,
            onBtnLeftClick: () => onDiscardChangesNoClick(location.pathname),
            onBtnRightClick: () => onDiscardChangesYesClick(idCardImages),
        });
        return false;
    };

    const onDiscardChangesNoClick = () => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
        deleteAllUnusedUploadedImages();
        onModalClose();
    };

    const onDiscardChangesYesClick = (idCardImages) => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
        onSaveProjectIdCard(idCardEditedData, idCardImages);
    };

    const discardChangesHandler = (idCardImages) => {
        let exitModal = {
            modalIsOpen: true,
            modalTitle: 'Unsaved data',
            leftBtnTitle: 'NO, Discard Changes',
            rightBtnTitle: 'YES, Save Changes',
            modalDescription: 'Your are about to leave this page without saving. Would you like to save all changes?',
            onCloseModal,
            onBtnLeftClick: () => onDiscardChangesNoClick(),
            onBtnRightClick: () => onDiscardChangesYesClick(idCardImages),
        };
        setModalData(exitModal);
    };

    const deleteAllUnusedUploadedImages = () => {
        // check for images that were uploaded but the changes weren't saved
        idCardImages.forEach((image) => {
            let containingImage = idCardImageArray.find((initialImage) => initialImage.imageId === image.imageId);
            if (containingImage === undefined) {
                deleteImage(image.imageId);
            }
        });
    };

    const onDeleteIdCard = (complete) => {
        setModalProp(MODAL_ACTION.IS_OPEN, false);
        deleteProjectIdCard({ id: idCardData.id, complete, onSuccessCallback: () => {
            updateSearchFilterField('refreshToggle', !searchFilter.refreshToggle);
            removeCatalogItem(idCardEditedData.projectId);
        }});
        onModalClose();
    };

    const deleteIdCardHandler = () => {
        let deleteModal = {
            modalIsOpen: true,
            modalTitle: 'Are you sure?',
            leftBtnTitle: 'All versions',
            rightBtnTitle: 'Just this version',
            modalDescription:
                'When deleting, you can choose to just delete the current version, or delete the complete version history from the database.',
            onCloseModal,
            onBtnLeftClick: () => onDeleteIdCard(true), // complete = true - Delete all versions
            onBtnRightClick: () => onDeleteIdCard(false), // complete = false - Delete latest version
        };

        setModalData(deleteModal);
    };

    const validationFunc = (field, value) => {
        if (value?.length > 1) {
            return true;
        } else {
            toast.error(`Please fill in a value for ` + field, {
                position: toast.POSITION.TOP_LEFT,
            });
            return false;
        }
    };

    const validationFuncNumeric = (field, value) => {
        return (!value || (value && !isNaN(value)));
    };

    const onSaveProjectIdCard = (idCardEditedData, idCardImages) => {
        const isCardValid = validationFunc('description', idCardEditedData.description);
        if (!isCardValid) {
            return;
        }
        saveChanges({ idCardEditedData, idCardImages });
    };

    const onSuccessImageUpload = (resData, imageFile, imageArrIndex) => {
        const updatedImages = [...idCardImages];
        updatedImages[imageArrIndex] = {
            imageId: resData,
            indexNr: imageArrIndex,
            legend: imageFile.name,
        };
        setIdCardImages(updatedImages);
    };

    const onSuccessImageRemove = (resData, imageFile, imageArrIndex) => {
        const updatedImages = [...idCardImages];
        updatedImages[imageArrIndex] = {
            imageId: null,
            indexNr: imageArrIndex,
            legend: '',
        };
        setIdCardImages(updatedImages);
    };

    const shouldSendDeleteImageReq = (imageId) => {
        let imageSavedInCard = idCardImageArray.find((image) => image.imageId === imageId);
        return !imageSavedInCard;
    };


    return <IdCardWrapper>
        {shouldRenderNotFound ? (
            <NotFound />
        ) : shouldRenderLoader ? (
            <SlotLoaderContainer>
                <Loader />
            </SlotLoaderContainer>
        ) : (
            <ImageContext.Provider
                value={{
                    idCardImages,
                    setIdCardImages,
                    onSuccessImageUpload,
                    onSuccessImageRemove,
                    shouldSendDeleteImageReq,
                }}>
                <Prompt
                    when={true}
                    message={(location, action) => {
                        return handleOnLeavePage(location, action);
                    }}
                />
                <ModalView
                    isOpen={modalData.modalIsOpen}
                    title={modalData.modalTitle}
                    description={modalData.modalDescription}
                    onCloseBtn={modalData.onCloseModal}
                    onBtnLeftClick={modalData.onBtnLeftClick}
                    onBtnRightClick={modalData.onBtnRightClick}
                    leftBtnTitle={modalData.leftBtnTitle}
                    rightBtnTitle={modalData.rightBtnTitle}
                />
                <TitleAndCommandsWrapper>
                    <TitlesWrapper>
                        <IdCardTitle>
                            <SectionTitleEl>{`${idCardData.projectNr ? idCardData.projectNr : ''} - ${idCardData.projectName ? idCardData.projectName : ''}`}</SectionTitleEl>
                        </IdCardTitle>
                        <ModuleTitle>
                            <SectionTitleEl>{`${idCardData.projectClient ?? ''}`}</SectionTitleEl>
                        </ModuleTitle>
                        <ModuleTitle>
                            <SectionTitleEl>{`${idCardData.projectLocation ?? ''}`}</SectionTitleEl>
                        </ModuleTitle>
                    </TitlesWrapper>
                    <CommandsWrapper>
                        <SaveChangesExitWrapper>
                            <SaveChangesButton
                                title={'Save changes'}
                                disabled={false}
                                onClick={() => onSaveProjectIdCard(idCardEditedData, idCardImages)}
                            />
                        </SaveChangesExitWrapper>
                        <DiscardChangesButton
                            type='transparentBackgroundButton'
                            title='Discard changes'
                            onClick={() => discardChangesHandler(idCardImages)}
                        />
                        <DeleteIdCardButton
                            type='transparentBackgroundButton'
                            title='Delete ID Card'
                            onClick={deleteIdCardHandler}
                        />
                    </CommandsWrapper>
                </TitleAndCommandsWrapper>
                <TextualDetailsWrapper>
                    <DescriptionAndMainImageWrapper>
                        <DescriptionAndScopeWrapper>
                            <SectionTitle>Description:</SectionTitle>
                            <DescriptionEdit style={{height:'200px',width:'80%'}}
                                text={idCardEditedData.description ?? ''}
                                onChange={(e) => setEditedDataField('description', e.target.value)}
                            />
                            <SectionTitle>SBM scope of work:</SectionTitle>
                            <DescriptionEdit style={{height:'200px',width:'80%'}}
                                text={idCardEditedData.scopeOfWork ?? ''}
                                onChange={(e) => setEditedDataField('scopeOfWork', e.target.value)}
                            />
                        </DescriptionAndScopeWrapper>
                        <MainImageEdit style={{margin:'40px 0px'}}
                            image={idCardImages[0]}
                            imageIndex={0}
                            hideLabel={true}
                        />
                    </DescriptionAndMainImageWrapper>
                </TextualDetailsWrapper>
                <ImagesWrapper>
                    <ImageWrapper>
                        <SectionTitle>General Arrangement:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                            image={idCardImages[1]}
                            imageIndex={1}
                            hideLabel={true}
                        />
                    </ImageWrapper>
                    <ImageWrapper>
                        <SectionTitle>Process Overview:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                            image={idCardImages[2]}
                            imageIndex={2}
                            hideLabel={true}
                        />
                    </ImageWrapper>
                    <ImageWrapper>
                        <SectionTitle>Field layout:</SectionTitle>
                        <MainImageEdit style={{height:'200px',width:'100%'}}
                            image={idCardImages[3]}
                            imageIndex={3}
                            hideLabel={true}
                        />
                    </ImageWrapper>
                </ImagesWrapper>
                <CharacteristicsAndModulesWrapper>
                    <CharacteristicsWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Project characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract type:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardEditedData.contractType}
                                    options={CONTRACT_TYPE_OPTIONS}
                                    placeholder='Contract type'
                                    onChange={(option) => {
                                        setEditedDataField('contractType', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract duration:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Contract duration'
                                    value={idCardEditedData.contractDuration ?? ''}
                                    onChange={(e) => setEditedDataField('contractDuration', e.target.value)}
                                    name='contractDuration'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Contract duration must be numeric'}
                                />
                                <CharacteristicUnit>year</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Mooring system:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardEditedData.mooringSystem}
                                    options={MOORING_SYSTEM_OPTIONS}
                                    placeholder='Mooring system'
                                    onChange={(option) => {
                                        setEditedDataField('mooringSystem', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Integration yard:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Integration yard'
                                    value={idCardEditedData.integrationYard ?? ''}
                                    onChange={(e) => setEditedDataField('integrationYard', e.target.value)}
                                    name='integrationYard'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr production risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr production risers'
                                    value={idCardEditedData.nrProductionRisers ?? ''}
                                    onChange={(e) => setEditedDataField('nrProductionRisers', e.target.value)}
                                    name='nrProductionRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr production risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr gas risers'
                                    value={idCardEditedData.nrGasRisers ?? ''}
                                    onChange={(e) => setEditedDataField('nrGasRisers', e.target.value)}
                                    name='nrGasRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr gas risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas export risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr gas export risers'
                                    value={idCardEditedData.nrGasExportRisers ?? ''}
                                    onChange={(e) => setEditedDataField('nrGasExportRisers', e.target.value)}
                                    name='nrGasExportRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr gas export risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr water risers:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Nr water risers'
                                    value={idCardEditedData.nrWaterRisers ?? ''}
                                    onChange={(e) => setEditedDataField('nrWaterRisers', e.target.value)}
                                    name='nrWaterRisers'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Nr water risers must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Hull dimensions (LxWxH):</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Hull dimensions'
                                    value={idCardEditedData.hullDimensions ?? ''}
                                    onChange={(e) => setEditedDataField('hullDimensions', e.target.value)}
                                    name='hullDimensions'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit>m</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Max POB:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Max POB'
                                    value={idCardEditedData.maxPob ?? ''}
                                    onChange={(e) => setEditedDataField('maxPob', e.target.value)}
                                    name='maxPob'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Max POB must be numeric'}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Field characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field name:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Field name'
                                    value={idCardEditedData.fieldName ?? ''}
                                    onChange={(e) => setEditedDataField('fieldName', e.target.value)}
                                    name='fieldName'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Distance from shore:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Distance from shore'
                                    value={idCardEditedData.distanceFromShore ?? ''}
                                    onChange={(e) => setEditedDataField('distanceFromShore', e.target.value)}
                                    name='distanceFromShore'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Distance from shore must be numeric'}
                                />
                                <CharacteristicUnit>km</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water depth:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Water depth'
                                    value={idCardEditedData.waterDepth ?? ''}
                                    onChange={(e) => setEditedDataField('waterDepth', e.target.value)}
                                    name='waterDepth'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Water depth must be numeric'}
                                />
                                <CharacteristicUnit>m</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field specifics:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Field specifics'
                                    value={idCardEditedData.fieldSpecifics ?? ''}
                                    onChange={(e) => setEditedDataField('fieldSpecifics', e.target.value)}
                                    name='fieldSpecifics'
                                    validation={() => true}
                                    errorMsg={''}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Crude oil viscosity:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Crude oil viscosity'
                                    value={idCardEditedData.crudeOilViscosity ?? ''}
                                    onChange={(e) => setEditedDataField('crudeOilViscosity', e.target.value)}
                                    name='crudeOilViscosity'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Contract duration must be numeric'}
                                />
                                <CharacteristicUnit>°API</CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>FPSO characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas blanketing:</CharacteristicTitle>
                                <Dropdown
                                    value={idCardEditedData.gasBlanketing}
                                    options={[{value:true,label:'Yes'},{value:false,label:'No'}]}
                                    placeholder='Gas blanketing'
                                    onChange={(option) => {
                                        setEditedDataField('gasBlanketing', option.value);
                                    }}
                                    externalStyles={{container:(styles) => ({
                                            ...styles,
                                            width: '50%',
                                            flex: '3',
                                        })}}
                                />
                                <CharacteristicUnit></CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Storage capacity:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Storage capacity'
                                    value={idCardEditedData.storageCapacity ?? ''}
                                    onChange={(e) => setEditedDataField('storageCapacity', e.target.value)}
                                    name='storageCapacity'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Storage capacity must be numeric'}
                                />
                                <CharacteristicUnit>m3</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Oil production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Oil production'
                                    value={idCardEditedData.oilProduction ?? ''}
                                    onChange={(e) => setEditedDataField('oilProduction', e.target.value)}
                                    name='oilProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Oil production must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Water production'
                                    value={idCardEditedData.waterProduction ?? ''}
                                    onChange={(e) => setEditedDataField('waterProduction', e.target.value)}
                                    name='waterProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Water production must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Total liquid:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Total liquid'
                                    value={idCardEditedData.totalLiquid ?? ''}
                                    onChange={(e) => setEditedDataField('totalLiquid', e.target.value)}
                                    name='totalLiquid'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Total liquid must be numeric'}
                                />
                                <CharacteristicUnit>bpd</CharacteristicUnit>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas production:</CharacteristicTitle>
                                <ValidationInput
                                    component={CharacteristicInput}
                                    containerStyle={{ width: '50%', height: '100%', flex:'3' }}
                                    placeholder='Gas production'
                                    value={idCardEditedData.gasProduction ?? ''}
                                    onChange={(e) => setEditedDataField('gasProduction', e.target.value)}
                                    name='gasProduction'
                                    validation={validationFuncNumeric}
                                    errorMsg={'Gas production must be numeric'}
                                />
                                <CharacteristicUnit>MM scfd</CharacteristicUnit>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                    </CharacteristicsWrapper>
                    <ModulesWrapper>
                        <SectionTitle>Modules:</SectionTitle>
                        {idCardEditedData.modules && idCardEditedData.modules.map(module =>
                            <ModuleWrapper onClick={() => addCatalogItem(module.tagId, false)} key={module.tagId}>
                                <ModuleImage>
                                    <ImageViewer
                                        imageId={module.imageId}
                                        fullscreen={false}
                                        defaultLoaderSize={35}
                                        containerStyle={{
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </ModuleImage>
                                <ModuleNameWrapper>
                                    <ModuleTsCode>{module.tsCode}</ModuleTsCode>
                                    <ModuleName>{module.name}</ModuleName>
                                </ModuleNameWrapper>
                            </ModuleWrapper>
                        )}
                    </ModulesWrapper>
                </CharacteristicsAndModulesWrapper>
                <SubMenusWrapper>
                    <SubMenuItem
                        title={'Documentation List'}
                        component={
                            <DocumentsEdit
                                documents={idCardEditedData.documents}
                                setEditedDataField={setEditedDataField}
                            />}
                    />
                </SubMenusWrapper>
            </ImageContext.Provider>
        )}
    </IdCardWrapper>
};

export default ProjectIdCardEdit;
